__turbopack_context__.v({
  "feverBarPulse": "LottoPotGauge-module-scss-module__dW-IWa__feverBarPulse",
  "feverSheen": "LottoPotGauge-module-scss-module__dW-IWa__feverSheen",
});
